import { Box, Typography, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import TargetAcheivedStars from '../../components/TargetAcheivedStars';
import StackedHorizontalBar from '../../components/Charts/StackedHorizontalBar';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getClubReviewsInfo, getInterviewers, getInterviewTeamUsers } from '../../api/evaluation';
import { setInterviewers, setInterviewTeams, setInterviewView } from '../../redux/reducers/evaluation';
import DataPreview from '../../components/DataPreview';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faTableList } from '@fortawesome/free-solid-svg-icons';
import { SwitchButton } from '../../components/SwitchButton';
import { colors } from '../../common/pallette/colors';
import { setAllActions, setIsActions } from '../../redux/reducers/actionPlan';
import { TextAreaWithoutBorders } from '../../components/TextAreaWithoutBorders';
import TextAreaOrderedList from '../../components/TextAreaOrderedList';
import { resetGoalsHeader, setGoalsHeader } from '../../redux/reducers/goalsAndStrategy';
import { getGoalsHeader, updateGoalsHeader } from '../../api/goals';
import { getAverageProjectStatus, PerformancePlanStatus, screenResolution } from '../../common/StaticExports';
import { getAllActions } from '../../api/action';
import { baseUrl } from '../../api/config';
import { useNavigate } from 'react-router';
import useWindowSize from '../../hooks/useWindowSize';
import './styles.css';

const PhaseHeader = (props:any) => {
    const { module } = props;
    const { width } = useWindowSize();
    const navigate = useNavigate();
    const clubDesirePlan = useSelector((state: any) => state.clubData.clubDesirePlan);
    const saCriteria = useSelector((state: any) => state.evaluation.saCriteria);
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const licenceCriteria = useSelector((state: any) => state.licence.licenceCriteria);
    const [statusData, setStatusData] = useState([]);
    const [t] = useTranslation();
    var [statusLabel, setStatusLabel] = useState(clubDetails.currentEvaluationPhase);
    const dispatch = useDispatch();
    const onSiteCriteria = useSelector((state:any) => state.evaluation.onSiteCriteria);
    const currentSection = useSelector((state:any) => state.evaluation.currentSection);
    const interviewers = useSelector((state:any) => state.evaluation.interviewers);
    const interviewView = useSelector((state:any) => state.evaluation.interviewView);
    const projects = useSelector((state:any) => state.actionPlan.projects);
    const allActions = useSelector((state:any) => state.actionPlan.allActions);
    const isActions = useSelector((state:any) => state.actionPlan.isActions);
    const goalsHeader = useSelector((state:any) => state.goalsAndStrategy.goalsHeader);
    const goals = useSelector((state:any) => state.goalsAndStrategy.goals);
    const jlActions = useSelector((state:any) => state.actionPlan.allActions)?.filter((item:any) => item?.isCreatedByJL == true);
    const clubActions = useSelector((state:any) => state.actionPlan.allActions)?.filter((item:any) => item?.isCreatedByJL == false);
    const [updatedGoalsHeader, setUpdatedGoalsHeader] = useState(false);
    const [projectsStatus, setProjectsStatus] = useState([]);
    const [actionsStatus, setActionsStatus] = useState([]);
    const [jlActionsStatus, setJlActionsStatus] = useState([]);
    const [goalsStatus, setGoalsStatus] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    const selectedTab:any = useSelector((state:any) => state.evaluation.currentEvaluationTab);
    const siteReviewPalette = [
      colors.grey.dark,
      colors.statusColors.met,
      colors.statusColors.partial,
      colors.statusColors.notMet
    ];
    const projectsPalette = [
      colors.lightishRed,
      colors.tangerine,
      colors.vibrantGreen,
      colors.gold,
      colors.middleGrey,
    ];

      const jla = [
        {
          name: "Not Evaluated",
          data: [0]
        },{
          name: "Met",
          data: [4]
        },
        {
          name: "Partial",
          data: [0]
        },
        {
          name: "Not Met",
          data: [2]
        }
      ]

      useEffect(() => {
        var notEval = 0;
        var met = 0;
        var partial = 0;
        var notMet = 0;
        if((saCriteria?.length && clubDetails?.currentEvaluationPhase != '') ||
      (licenceCriteria?.length && module == 'LICENCE')) {
        setIsLoading(true);
          var key = '';
          var listToIterate = [];
          const caseString = module == 'EVALUATION' ? 
          (selectedTab == t('ON_SITE') ? t('ON_SITE') : clubDetails.currentEvaluationPhase) :
          module;
          switch(caseString) {
            case 'SELF_ASSESSMENT':
              key = 'offSiteStatus';
              setStatusLabel('OFF_SITE');
              listToIterate = saCriteria;
              break;
            case 'OFF_SITE':
              key = 'offSiteStatus';
              listToIterate = saCriteria;
              break;
            case 'ON_SITE':
              key = 'onSiteStatus';
              listToIterate = saCriteria;
              break;
            case t('ON_SITE'):
              key = 'status';
              listToIterate = onSiteCriteria;
              break;
            case 'INTERIM_REPORT':
              key = 'interimReportStatus';
              listToIterate = saCriteria;
              break;
            case 'FINAL_REPORT':
              key = 'finalReportStatus';
              listToIterate = saCriteria;
              break;
            case 'LICENCE':
              key = 'status';
              listToIterate = licenceCriteria;
              setStatusLabel('LICENCE_EVALUATION');
              break;
          }
          listToIterate?.map((d:any) => {
            switch(d[key]){
              case 0:
                notEval++;
                break;
              case 1:
                notMet++;
                break;
              case 2:
                partial++;
                break;
              case 3:
                met++;
                break;
            }
          });
          const tempData:any = [
            {
              name: "NOT_EVALUATED",
              data: [notEval],
            },
            {
              name: "MET",
              data: [met],
            },
            {
              name: "PARTIAL",
              data: [partial]
            },
            {
              name: "NOT_MET",
              data: [notMet]
            }
          ];
          setStatusData(tempData);
          setIsLoading(false);
        }
      }, [saCriteria, clubDetails, module, selectedTab, onSiteCriteria]);

      useEffect(() => {
        if ((module == 'EVALUATION' && allActions)) {
          var missed = 0;
          var atRisk = 0;
          var onTrack = 0;
          var completed = 0;
          var notStarted = 0;
          const tempArr = isAdmin ? jlActions : clubActions;
          tempArr.map((item:any) => {
            switch(item?.ragb) {
              case 0:
                missed++;
                break;
              case 1:
                atRisk++;
                break;
              case 2:
                onTrack++;
                break;
              case 3:
                completed++;
                break;
              case 4:
                notStarted++;
                break;
            }
          });
          const tempData:any = [
            {
              name: "MISSED",
              data: [missed],
            },
            {
              name: "AT_RISK",
              data: [atRisk],
            },
            {
              name: "ON_TRACK",
              data: [onTrack]
            },
            {
              name: "COMPLETED",
              data: [completed]
            },
            {
              name: "NOT_STARTED",
              data: [notStarted]
            }
          ];
          
          setJlActionsStatus(tempData);
        }
      }, [module, allActions]);

      useEffect(() => {
        if ((module == t('ACTION_PLAN') && !isActions && projects) || (module == t('ACTION_PLAN') && isActions && allActions)) {
          var missed = 0;
          var atRisk = 0;
          var onTrack = 0;
          var completed = 0;
          var notStarted = 0;
          const tempArr = isActions ? allActions : projects;
          tempArr.map((item:any) => {
            switch(item.ragb) {
              case 0:
                missed++;
                break;
              case 1:
                atRisk++;
                break;
              case 2:
                onTrack++;
                break;
              case 3:
                completed++;
                break;
              case 4:
                notStarted++;
                break;
            }
          });
          const tempData:any = [
            {
              name: "MISSED",
              data: [missed],
            },
            {
              name: "AT_RISK",
              data: [atRisk],
            },
            {
              name: "ON_TRACK",
              data: [onTrack]
            },
            {
              name: "COMPLETED",
              data: [completed]
            },
            {
              name: "NOT_STARTED",
              data: [notStarted]
            }
          ];
          if (module == t('ACTION_PLAN')) {
            if(isActions) {
              setActionsStatus(tempData);
            } else {
              setProjectsStatus(tempData);
            }
          }
        }
      }, [module, projects, allActions]);

      const fetchGoalsStatuses = () => {
        var goalsCalculatedStatuses:any = [];
        goals.map((item:any) => {
          const statuses = item?.subGoals ? item?.subGoals.map((item:any) => item?.status ? item?.status : PerformancePlanStatus.NotStarted) : [];
          var tempStatus = item?.subGoals && item?.subGoals?.length > 0 ? getAverageProjectStatus(statuses) : (item?.status || PerformancePlanStatus.NotStarted);
          goalsCalculatedStatuses.push(tempStatus);
        })
        return goalsCalculatedStatuses;
      }
      useEffect(() => {
        if (module == t('ACADEMY_GOALS') && goals) {
          var missed = 0;
          var atRisk = 0;
          var onTrack = 0;
          var completed = 0;
          var notStarted = 0;
          const tempArr = fetchGoalsStatuses();
          tempArr.map((item:any) => {
            switch(item) {
              case 0:
                missed++;
                break;
              case 1:
                atRisk++;
                break;
              case 2:
                onTrack++;
                break;
              case 3:
                completed++;
                break;
              case 4:
                notStarted++;
                break;
            }
          });
          const tempData:any = [
            {
              name: "MISSED",
              data: [missed],
            },
            {
              name: "AT_RISK",
              data: [atRisk],
            },
            {
              name: "ON_TRACK",
              data: [onTrack]
            },
            {
              name: "COMPLETED",
              data: [completed]
            },
            {
              name: "NOT_STARTED",
              data: [notStarted]
            }
          ];
          setGoalsStatus(tempData);
        }
      }, [module, goals]);

      const fetchOnSiteSupport = async () => {
        const reviewData = await getClubReviewsInfo({clubId: clubDetails?.id});
        const response = await getInterviewTeamUsers({onSiteReviewId: reviewData?.onSiteReviewId});
        const interviewers = await getInterviewers({onSiteReviewId: reviewData?.onSiteReviewId});
        const sortedInterviewers = interviewers.map((item:any) => {
          if (item.displayName == null) {
            const tempObj = response.find((d:any) => d.id == item.userId);
            if (tempObj) {
              return {...item, 
                      displayName: tempObj.displayName, 
                      roleName: tempObj.roleName, 
                      avatarPath: tempObj?.avatarPath ? tempObj?.avatarPath : ''};
            } else {
              return {...item, displayName: 'No Name', roleName: 'No Roles', avatarPath: ''};
            }
          } return {...item, roleName: ''};
        })
        dispatch(setInterviewers(sortedInterviewers));
        dispatch(setInterviewTeams(response));
      }

      //fetching goals header
      const fetchGoalsHeader = async () => {
        const response = await getGoalsHeader(!isAdmin && { clubId: clubDetails?.id });
        if(response == null) {
          dispatch(resetGoalsHeader());
        } else {
          dispatch(setGoalsHeader(response));
        }
      }

      const fetchAllActions = async () => {
        const response = await getAllActions({ clubId: clubDetails?.id });
        dispatch(setAllActions(response));
      }

      useEffect(() => {
        (module == 'EVALUATION' && currentSection == t('ON_SITE')) &&
        fetchOnSiteSupport();

        module == t('ACADEMY_GOALS') &&
        fetchGoalsHeader();

        (module == 'EVALUATION' && !allActions) &&
        fetchAllActions();

      }, [clubDetails, currentSection, module]);

      //managing goals header changes
      const manageGoalsHeaderChange = (key:any, updatedData:any) => {
        const tempObj = { ...goalsHeader, [key]: updatedData };
        dispatch(setGoalsHeader(tempObj));
        setUpdatedGoalsHeader(true);
      }
      //updating goals header api
      const updateGoalsHeaderChanges = async () => {
        if(updatedGoalsHeader) {
          const response = await updateGoalsHeader({ clubId: !isAdmin ? clubDetails?.id : null, header: goalsHeader });
          if(response == null) {
            dispatch(resetGoalsHeader());
          } else {
            dispatch(setGoalsHeader(response));
          }
          setUpdatedGoalsHeader(false);
        }
      }

    const fetchWidth = () => {
      if (width < screenResolution.mobile) {
        return 150;
      } else if (width < screenResolution.standardRablet) {
        return 200;
      }
      return 300;
    }
      
    return(
        <React.Fragment>
          {/* Evaluation Content */}
          {
            module == 'EVALUATION' && currentSection != t('REPORTS') && 
            <Box className={'finalReportWrapper'}>
              <TargetAcheivedStars label='current' acheived={clubDesirePlan.achievedStarRating ? clubDesirePlan.achievedStarRating : 0}/>
              <TargetAcheivedStars label='target' acheived={clubDesirePlan.starRating ?  clubDesirePlan.starRating : 0}/>
              <Box className={'stackedBarWrapper'}>
                <StackedHorizontalBar 
                data={statusData} 
                label={selectedTab == t('ON_SITE') ? t('ON_SITE') : t(statusLabel)} 
                colorPalette={siteReviewPalette} width={fetchWidth()} />
              </Box>
              {
                (currentSection == t('ON_SITE')) ?
                <DataPreview data={interviewers} label={'Interview Team'}/>:
                jlActions && jlActions?.length > 0 &&
                <Box className={'stackedBarWrapper'}>
                <StackedHorizontalBar 
                data={jlActionsStatus} 
                label={isAdmin ? 'Open JL Actions' : 'Club Actions'} 
                colorPalette={projectsPalette} width={fetchWidth()}/>
                </Box>
              }
              {
                  (currentSection == t('ON_SITE')) &&
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '120px', mr: '20px' }}>
                    <Box sx={{ m: 'auto' }}>
                      <Tooltip title='List View' arrow placement='top'>
                        <FontAwesomeIcon className={interviewView == 'LIST' ? 'selectedIconColor fs24' : 'icon fs24'} icon={faTableList} onClick={() => {dispatch(setInterviewView('LIST'))}} />
                      </Tooltip>
                    </Box>
                    <Box sx={{ m: 'auto' }}>
                      <Tooltip title='Calendar View' arrow placement='top'>
                        <FontAwesomeIcon className={interviewView == 'CALENDAR' ? 'selectedIconColor fs24 mb2' : 'icon fs24 mb2'} icon={faCalendarDays} onClick={() => {dispatch(setInterviewView('CALENDAR'))}} />
                      </Tooltip>
                    </Box>
                  </Box>
                }
            </Box>
          }
          {/* Performance Plan Content */}
          {
            module == t('ACTION_PLAN') &&
            <Box className={'finalReportWrapper'} sx={{ display: 'flex', justifyContent: 'space-between', my: 2 }}>
              <StackedHorizontalBar data={isActions ? actionsStatus : projectsStatus} label={isActions ? 'Actions Status' : 'Project Status'} colorPalette={projectsPalette} width={300}/>
              <SwitchButton 
              label={'Projects'}
              label01={'Actions'}
              isOn={isActions}
              handleOnClick={() => {
                const changeBool:any = !isActions;
                dispatch(setIsActions(changeBool));
                if (changeBool) {
                  navigate('/performanceplan/actions');
                } else {
                  navigate('/performanceplan/projects');
                }
              }}
              />
            </Box>
          }
          {/* Goals & Strategy Content */}
          {
            module == t('ACADEMY_GOALS') &&
            <Box className={'finalReportWrapper'} sx={{ display: 'flex', justifyContent: 'space-between', my: 2 }}>
              <Box sx={{ display: 'flex', width: '30%' }}>
                <Typography className={'fs14 fw700 mr10 uppercase'} sx={{ width: '70px', textAlign: 'left' }}>{t('ACADEMY_VISION')}</Typography>
                <Box sx={{ width: '80%' }}>
                  <TextAreaWithoutBorders 
                  value={goalsHeader?.vision ? goalsHeader?.vision : ''}
                  rows={2}
                  handleChange={(e:any) => {manageGoalsHeaderChange('vision', e.target.value)}}
                  placeholder={t('ACADEMY_VISION_PLACEHOLDER')}
                  manageOnBlur={updateGoalsHeaderChanges}
                  isResize={true}/>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', width: '30%' }}>
                <Typography className={'fs14 fw700 mr10 uppercase'} sx={{ width: '90px', textAlign: 'left' }}>{t('ACADEMY_NORTH_STAR')}</Typography>
                <Box sx={{ width: '80%' }}>
                  <TextAreaOrderedList 
                  value={goalsHeader?.northStar ? goalsHeader?.northStar : ''}
                  rows={2} 
                  handleChange={(e:any) => {manageGoalsHeaderChange('northStar', e)}}
                  placeholder={t('ACADEMY_NORTH_STAR_PLACEHOLDER')}
                  manageOnBlur={updateGoalsHeaderChanges} />
                </Box>
              </Box>
              { goals && goals?.length > 0 && <StackedHorizontalBar data={goalsStatus} label={t('GOALS_STATUS')} colorPalette={projectsPalette} width={300}/>}
            </Box>
          }
        </React.Fragment>
    )
}

export default PhaseHeader;